export default "__VITE_ASSET__UAe7vkye__"